module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-1700.0e3b8d5d.svg";